var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgViewIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.0002 12.5C9.42965 13.0741 9.97756 13.5492 10.6067 13.8929C11.2359 14.2367 11.9317 14.4411 12.6468 14.4923C13.362 14.5435 14.0798 14.4404 14.7515 14.1898C15.4233 13.9392 16.0333 13.5471 16.5402 13.04L19.5402 10.04C20.451 9.09699 20.955 7.83397 20.9436 6.52299C20.9322 5.21201 20.4063 3.95794 19.4793 3.0309C18.5523 2.10386 17.2982 1.57802 15.9872 1.56663C14.6762 1.55523 13.4132 2.05921 12.4702 2.97L10.7502 4.68M13.0002 10.5C12.5707 9.92587 12.0228 9.45081 11.3936 9.10706C10.7645 8.7633 10.0687 8.55888 9.35355 8.50766C8.63841 8.45645 7.92061 8.55963 7.24885 8.81021C6.5771 9.0608 5.96709 9.45293 5.4602 9.96L2.4602 12.96C1.54941 13.903 1.04544 15.166 1.05683 16.477C1.06822 17.788 1.59407 19.042 2.52111 19.9691C3.44815 20.8961 4.70221 21.422 6.01319 21.4334C7.32418 21.4448 8.58719 20.9408 9.5302 20.03L11.2402 18.32",
    stroke: "#98A2B3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewIcon);
export default __webpack_public_path__ + "static/media/viewIcon.64b78c5050f54f7ef6b2a0b416b78a78.svg";
export { ForwardRef as ReactComponent };